// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { GlobalService } from '../generated/api/global.service';

@Injectable({ providedIn: 'root' })
export class GlobalClientService {
  constructor(private readonly client: GlobalService) {}
  // <generated-client-wrappers:methods>
  addAnalytic(
    analytic: WrapperApi.Analytic,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<string> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalAddAnalytic(
      analytic,
      'body',
      reportProgress,
      options,
    );
  }

  addCategory(
    entityTag: Array<WrapperApi.EntityTag>,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<string> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalAddCategory(
      entityTag,
      'body',
      reportProgress,
      options,
    );
  }

  addDiagnostic(
    diagnostic: WrapperApi.Diagnostic,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<string> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalAddDiagnostic(
      diagnostic,
      'body',
      reportProgress,
      options,
    );
  }

  categoryByName(
    searchParam?: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.Tag> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalCategoryByName(
      searchParam,
      'body',
      reportProgress,
      options,
    );
  }

  categoryExistAdd(
    tag: WrapperApi.Tag,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.Tag> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalCategoryExistAdd(
      tag,
      'body',
      reportProgress,
      options,
    );
  }

  editCategory(
    entityTag: Array<WrapperApi.EntityTag>,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<string> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalEditCategory(
      entityTag,
      'body',
      reportProgress,
      options,
    );
  }

  evaluateFeatureFlag(
    name: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.FeatureFlagEvaluationResult> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalEvaluateFeatureFlag(
      name,
      'body',
      reportProgress,
      options,
    );
  }

  getAddressTypes(
    keyword?: string,
    page?: number,
    size?: number,
    requiredItems?: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.AddressType>> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetAddressTypes(
      keyword,
      page,
      size,
      requiredItems,
      'body',
      reportProgress,
      options,
    );
  }

  getAllAnalytic(
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.Analytic>> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetAllAnalytic('body', reportProgress, options);
  }

  getAllDiagnostics(
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.Diagnostic>> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetAllDiagnostics('body', reportProgress, options);
  }

  getAnalytic(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.Analytic> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetAnalytic(id, 'body', reportProgress, options);
  }

  getCategory(
    searchParam?: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.Tag>> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetCategory(
      searchParam,
      'body',
      reportProgress,
      options,
    );
  }

  getCountries(
    keyword?: string,
    page?: number,
    size?: number,
    requiredItems?: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.CountryPhoneCode>> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetCountries(
      keyword,
      page,
      size,
      requiredItems,
      'body',
      reportProgress,
      options,
    );
  }

  getCountriesByKeyword(
    keyword?: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<{
    [key: string]: string;
  }> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetCountriesByKeyword(
      keyword,
      'body',
      reportProgress,
      options,
    );
  }

  getCurrencies(
    keyword?: string,
    page?: number,
    size?: number,
    requiredItems?: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.Currency>> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetCurrencies(
      keyword,
      page,
      size,
      requiredItems,
      'body',
      reportProgress,
      options,
    );
  }

  getCurrenciesByCountryOrCurrencyCode(
    keyword?: string,
    page?: number,
    size?: number,
    requiredItems?: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.Currency>> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetCurrenciesByCountryOrCurrencyCode(
      keyword,
      page,
      size,
      requiredItems,
      'body',
      reportProgress,
      options,
    );
  }

  getCurrencyByCountryCode(
    countryCode: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.Currency> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetCurrencyByCountryCode(
      countryCode,
      'body',
      reportProgress,
      options,
    );
  }

  getCurrencyByCurrencyCode(
    currencyCode: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.Currency> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetCurrencyByCurrencyCode(
      currencyCode,
      'body',
      reportProgress,
      options,
    );
  }

  getCurrentLegalDocumentByKey(
    key: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.LegalCurrentDocument> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetCurrentLegalDocumentByKey(
      key,
      'body',
      reportProgress,
      options,
    );
  }

  getCurrentLegalDocumentByType(
    type?: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.LegalCurrentDocument> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetCurrentLegalDocumentByType(
      type,
      'body',
      reportProgress,
      options,
    );
  }

  getDateTimeFormats(
    keyword?: string,
    page?: number,
    size?: number,
    requiredItems?: string,
    featuredOnly?: boolean,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.DateTimeFormat>> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetDateTimeFormats(
      keyword,
      page,
      size,
      requiredItems,
      featuredOnly,
      'body',
      reportProgress,
      options,
    );
  }

  getDiagnostic(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.Diagnostic> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetDiagnostic(id, 'body', reportProgress, options);
  }

  getDocumentTypes(
    keyword?: string,
    page?: number,
    size?: number,
    requiredItems?: string,
    featuredOnly?: boolean,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.DocumentType>> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetDocumentTypes(
      keyword,
      page,
      size,
      requiredItems,
      featuredOnly,
      'body',
      reportProgress,
      options,
    );
  }

  getEntityCategory(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.Tag>> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetEntityCategory(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  getFeatureFlagsBulkSnapshot(
    request: WrapperApi.FeatureFlagSnapshotRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.FeatureFlagSnapshot> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetFeatureFlagsBulkSnapshot(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  getFeatureFlagsSnapshot(
    names?: Array<string>,
    includeInactive?: boolean,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.FeatureFlagSnapshot> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetFeatureFlagsSnapshot(
      names,
      includeInactive,
      'body',
      reportProgress,
      options,
    );
  }

  getGender(
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.Language>> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetGender('body', reportProgress, options);
  }

  getIPAddress(
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<number> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetIPAddress('body', reportProgress, options);
  }

  getLanguages(
    keyword?: string,
    page?: number,
    size?: number,
    requiredItems?: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.Language>> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetLanguages(
      keyword,
      page,
      size,
      requiredItems,
      'body',
      reportProgress,
      options,
    );
  }

  getLocales(
    keyword?: string,
    page?: number,
    size?: number,
    requiredItems?: string,
    featuredOnly?: boolean,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.Locale>> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetLocales(
      keyword,
      page,
      size,
      requiredItems,
      featuredOnly,
      'body',
      reportProgress,
      options,
    );
  }

  getPhoneCodes(
    page?: number,
    size?: number,
    requiredItems?: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<{
    [key: string]: string;
  }> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetPhoneCodes(
      page,
      size,
      requiredItems,
      'body',
      reportProgress,
      options,
    );
  }

  getPhoneCodesByKeyword(
    keyword?: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<{
    [key: string]: string;
  }> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetPhoneCodesByKeyword(
      keyword,
      'body',
      reportProgress,
      options,
    );
  }

  getSpeedByUrl(
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.InternetSpeed> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetSpeedByUrl('body', reportProgress, options);
  }

  getSubdivisions(
    countryCode?: string,
    keyword?: string,
    page?: number,
    size?: number,
    requiredItems?: string,
    featuredOnly?: boolean,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.Subdivision>> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetSubdivisions(
      countryCode,
      keyword,
      page,
      size,
      requiredItems,
      featuredOnly,
      'body',
      reportProgress,
      options,
    );
  }

  getTimeZones(
    keyword?: string,
    page?: number,
    size?: number,
    requiredItems?: string,
    featuredOnly?: boolean,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<Array<WrapperApi.TimeZone>> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalGetTimeZones(
      keyword,
      page,
      size,
      requiredItems,
      featuredOnly,
      'body',
      reportProgress,
      options,
    );
  }

  includeCategories(
    tags: Array<WrapperApi.Tag>,
    id?: string,
    appId?: string,
    entityName?: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<string> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalIncludeCategories(
      tags,
      id,
      appId,
      entityName,
      'body',
      reportProgress,
      options,
    );
  }

  includeCategory(
    tag: WrapperApi.Tag,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.Tag> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalIncludeCategory(
      tag,
      'body',
      reportProgress,
      options,
    );
  }

  submitFeedback(
    request: WrapperApi.FeedbackSubmitRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.FeedbackDetail> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalSubmitFeedback(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  submitLegalAcceptance(
    request: WrapperApi.LegalAcceptanceSubmitRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.LegalAcceptanceDetail> {
    if (!this.client) throw new Error('GlobalService is not available');
    return this.client.globalSubmitLegalAcceptance(
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
